import { Client, ClientKind } from '../types';

export type CreateLeadOption = {
  __createLead: true;
  name: string;
};

export type ContactAutocompleteOption = Client | CreateLeadOption;

export function isCreateLeadOption(option: ContactAutocompleteOption): option is CreateLeadOption {
  return '__createLead' in option;
}

export function contactKind(option: Client): ClientKind {
  return option.kind ?? 'client';
}

export function sortContactsForPicker(contacts: Client[]): Client[] {
  return [...contacts].sort((a, b) => {
    const kindOrder = (contactKind(a) === 'client' ? 0 : 1) - (contactKind(b) === 'client' ? 0 : 1);
    if (kindOrder !== 0) return kindOrder;
    return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
  });
}

export function groupContactOption(option: ContactAutocompleteOption): string {
  if (isCreateLeadOption(option)) return '';
  return contactKind(option) === 'client' ? 'Clients' : 'Leads';
}

export function buildContactAutocompleteOptions(
  contacts: Client[],
  inputValue: string,
  hasExactNameMatch: (name: string) => boolean,
): ContactAutocompleteOption[] {
  const sorted = sortContactsForPicker(contacts);
  const query = inputValue.trim();
  if (query && !hasExactNameMatch(query)) {
    return [...sorted, { __createLead: true, name: query }];
  }
  return sorted;
}

export function getContactOptionLabel(option: ContactAutocompleteOption): string {
  if (isCreateLeadOption(option)) {
    return `Create lead "${option.name}"`;
  }
  return option.name;
}
